.DiceLayout {
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(3, 1fr);
  grid-template-areas: "a c e" "b d f";
  font-size: 0.27em;
  opacity: 1;
  transition-delay: 0.5s;
  transition-duration: 1.5s;
  transition-property: opacity;
  gap: 0.1em;
  border-style: solid;
  border-width: 0.2em;
  border-radius: 0.2em;
  border-color: #111111;
  background-color: #111111;
  box-sizing: border-box;
}
.DiceLayout .DiceFace {
  border: none;
}
